import React, { useContext, useState, useEffect } from "react";
import { ethers } from "ethers";
import { NFTABI, NFTAddress } from "../utils/constants";

export const NFTContext = React.createContext();

export const NFTProvider = ({ children }) => {
  const [currentAccount, setCurrentAccount] = useState(null);
  const [currentCID, setCurrentCID] = useState(null);  // <-- new state variable for CID
  
  const getNftConnection = () => {
    if (typeof window === "undefined" || typeof window.ethereum === "undefined") {
      return { provider: null, signer: null, nftContract: null };
    }

    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const nftContract = new ethers.Contract(NFTAddress, NFTABI, signer);
    return { provider, signer, nftContract };
  };

  useEffect(() => {
    const init = async () => {
      const { provider } = getNftConnection();
      if (provider) {  // <-- Check if provider is defined
        const accounts = await provider.listAccounts();
        setCurrentAccount(accounts[0]);
      }
    };

    init();
  }, []);

  const mintNFT = async (recipient, uri) => {
    try {
      const { nftContract } = getNftConnection();
      if (nftContract) {  // <-- Check if nftContract is defined
        const tx = await nftContract.mintNFT(recipient, uri);  // Both arguments are passed
        await tx.wait();  // Wait for the transaction to be mined
        setCurrentCID(uri);  // <-- set the CID after successfully minting
        return tx;
      }
    } catch (error) {
      console.error("An error occurred: ", error);
    }
  };

  return (
    <NFTContext.Provider value={{ mintNFT, currentAccount, currentCID, setCurrentCID }}>  {/* <-- Expose the CID and its setter */}
      {children}
    </NFTContext.Provider>
  );
};

export const useNFT = () => {
  return useContext(NFTContext);
};



